import { Agent, AgentKeys } from '@ag-common-lib/public-api';
import { Injectable } from '@angular/core';
import { AgentSearchService, ConferenceService, DynamicSegmentsGroupService } from 'ag-common-svc/public-api';
import { from, map, shareReplay } from 'rxjs';

@Injectable()
export class NotificationAddSegmentsModalService {
  agents$ = from(
    this.agentSearchService.search({ sort: [{ selector: AgentKeys.p_agent_first_name, desc: false }] }),
  ).pipe(map(response => (response?.data ?? []) as Agent[]));
  conferences$ = this.conferenceService.getList().pipe(shareReplay(1));
  segments$ = this.dynamicSegmentsGroupService.segments$;

  constructor(
    private agentSearchService: AgentSearchService,
    private conferenceService: ConferenceService,
    private dynamicSegmentsGroupService: DynamicSegmentsGroupService,
  ) {}
}
